<div [ngClass]="{'fundo': !isMobile}">
    
</div>